import { ReactNode } from 'react';
import { Blockie, Link } from '@/components';
import { Flex, addressShortener, FlexProps, Box } from '@blockanalitica/ui';
import { LinkProps } from 'react-router-dom';
import type { Size } from '@blockanalitica/ui/package/types/src/theme/types';

export interface VaultNameProps extends FlexProps {
  urn: string;
  cdp?: string;
  iconSize?: number | Size;
  to?: LinkProps['to'];
}

function Wrapper({ to, children }: { to?: string; children: ReactNode }) {
  if (to) {
    return (
      <Link to={to} relative="path">
        {children}
      </Link>
    );
  }
  return <>{children}</>;
}

export default function VaultName({
  urn,
  cdp,
  iconSize = '5',
  to,
  ...rest
}: VaultNameProps) {
  const address = addressShortener({ address: urn });
  return (
    // @ts-ignore
    <Wrapper to={to} relative="path">
      <Flex gap="xs" alignItems="center" {...rest}>
        <Blockie address={urn} imgSize={iconSize} />

        {cdp ? (
          <Flex flexDirection="column" gap="3xs">
            {cdp}
            <Box fontSize="-1" color="muted">
              {address}
            </Box>
          </Flex>
        ) : (
          address
        )}
      </Flex>
    </Wrapper>
  );
}
